// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KuOj","menuButton":"Header_menuButton__1ONS3","Title":"Header_Title__3MblN","titleLink":"Header_titleLink__qSI6K"};